<template>
    <div class="mt-3 row cursor-pointer">
        <div class="col-md-4 col-lg-3 mt-md-0 mt-3 mb-2" @click.prevent="toggleComponent('DetailedExtract', 0)">
            <default-counter-card :count="parseInt(props.parcels.em_atraso)" title="Parcelas Atrasadas"
                prefix="Parcelas " suffix="Atrasadas" class="card-hover" />
        </div>
        <div class="col-md-4 col-lg-3 mt-md-0 mt-3" @click.prevent="toggleComponent('DetailedExtract', 1)">
            <default-counter-card :count="parseInt(props.parcels.pagas)" title="Parcelas Pagas" prefix="Parcelas "
                suffix="Pagas" class="card-hover" />
        </div>
        <div class="col-md-4 col-lg-3 mt-md-0 mt-3 position-relative" @click.prevent="toggleComponent('DetailedExtract', 2)">
            <span v-if="temSegundaVia" class="badge-segunda-via" title="Possui segunda via em aberto">
                <i class="fas fa-exclamation"></i>
            </span>
            <default-counter-card :count="parseInt(props.parcels.a_pagar) + parseInt(props.parcels.em_aberto)" title="Parcelas Futuras" prefix="Parcelas "
                suffix="Futuras" class="card-hover" :class="{ 'segunda-via-highlight': temSegundaVia }" />
        </div>
        <a v-if="getCurrentComponent() != 'FinancialCenter'" href="#" class="col-md-12 col-lg-3 mt-md-0 mt-3"
            @click="toggleComponent('FinancialCenter')">
            <div class="card" style="background-color: #EADDEF;">
                <div class="text-center card-body">
                    <img src="../../../../../assets/img/line-chart.svg" class="avatar"
                        style="width: 100px; height: 60px;" alt="icon chart" />
                    <div class="mt-2" style="font-size: 16px;">
                        Central
                    </div>
                    <div class="font-weight-bolder" style="white-space: nowrap;text-overflow: ellipsis">
                        Financeira
                    </div>
                    <h6 class="mb-0 font-weight-bolder">{{ title }}</h6>
                    <p class="mb-0 text-sm opacity-8">{{ description }}</p>
                </div>
            </div>
        </a>
        <a v-else href="#" class="col-md-12 col-lg-3 mt-md-0 mt-3"
            @click.prevent="toggleComponent('DetailedExtract', 0)">
            <div class="card" style="background-color: #EADDEF;">
                <div class="text-center card-body">
                    <img src="../../../../../assets/img/line-chart.svg" class="avatar"
                        style="width: 100px; height: 65px;" alt="icon chart" />
                    <div class="mt-2" style="font-size: 14px;">
                        Extrato
                    </div>
                    <div class="font-weight-bolder" style="white-space: nowrap;text-overflow: ellipsis">
                        Detalhado
                    </div>
                </div>
            </div>
        </a>
    </div>
</template>

<script setup>

import DefaultCounterCard from "@/examples/Cards/DefaultCounterCard.vue";
import { useStore } from "vuex";
import { computed, ref } from 'vue'

const store = useStore();
const currentComponent = ref('')
const props = defineProps({
    parcels: {
        type: Object,
        required: true
    },
});

const temSegundaVia = computed(() => parseInt(props.parcels.segunda_via || 0) > 0);


const toggleComponent = (component, tab) => {
    localStorage.setItem('FinancialTab', tab)
    store.commit("updateComponent", component)
};

const getCurrentComponent = () => {
    currentComponent.value = localStorage.getItem('currentComponent')

    return currentComponent.value
};

</script>

<style>
/* Para telas pequenas (sm) - ajuste conforme necessário */
@media (min-width: 576px) {
    .height-sm-124 {
        height: 124px !important;
    }
}

/* Para telas médias (md) e acima - ajuste conforme necessário */
@media (min-width: 768px) {
    .height-md-144 {
        height: 144px !important;
    }
}

/* Para telas grandes (lg) e acima - ajuste conforme necessário */
@media (min-width: 992px) {
    .height-lg-144 {
        height: 144px !important;
    }
}

/* Para telas extra grandes (xl) e acima - ajuste conforme necessário */
@media (min-width: 1200px) {
    .height-xl-144 {
        height: 144px !important;
    }
}

.card-hover:hover {
    background-color: #EADDEF !important;
}

.badge-segunda-via {
    position: absolute;
    top: -5px;
    right: 5px;
    z-index: 10;
    background-color: #FF9800;
    color: white;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
}

.segunda-via-highlight h1 {
    color: #FF9800 !important;
}

.fixed-size-card {
    width: 250px !important;
    /* Defina a largura desejada */
    height: 350px;
    /* Defina a altura desejada */
}
</style>